import React, { FC, ReactNode } from 'react'
import { FlexRow } from 'components/Flex'
import { Description, SubHeadline } from 'components/Typography'
import { HorizontalLine, Spacer } from 'components/Utility'
import { Card, CardInner } from 'components/Card'

type Props = {
  buttonComponent: React.ReactElement
  dataCy?: string
  description?: string
  title: string
  children: ReactNode
}

const BasicCard: FC<Props> = (props) => {
  const { buttonComponent, children, dataCy = '', description, title } = props
  return (
    <Card dataCy={dataCy}>
      <CardInner>
        <FlexRow justifyContent={'between'}>
          <SubHeadline headline={title} />
          {buttonComponent}
        </FlexRow>
        {description && (
          <>
            <Spacer size={16} />
            <Description description={description} />
          </>
        )}
      </CardInner>
      <HorizontalLine verticalMargin={16} />
      <CardInner>{children}</CardInner>
    </Card>
  )
}

export default BasicCard
